<template>
	<div class="f-table-footer" :class="{ 'is-collapse': isCollapse }">
		<div class="flex align-items-center">
			<div v-if="checkbox" class="checkbox">
				<el-checkbox v-model="isCheckAll" :indeterminate="isIndeterminate" :disabled="tableTotalLength === 0" @change="onCheckAllChange">
					<span v-if="!tableSelectionLength">全选</span>
					<span v-else>已选{{ tableSelectionLength }}个</span>
				</el-checkbox>
			</div>
			<div class="left">
				<slot name="left" />
			</div>
		</div>
		<div class="right">
			<f-pagination :total="total" :pindex.sync="currentPage" :psize.sync="pageSize" @change="paginationChange" />
		</div>
	</div>
</template>

<script>
export default {
	name: "FTableFooter",
	props: {
		checkbox: {
			type: Boolean,
			default: false,
		},
		list: {
			type: Array,
			default: () => [],
		},
		selection: {
			type: Array,
			default: () => [],
		},
		total: {
			type: Number,
			default: 0,
		},
		pindex: {
			type: Number,
			default: 0,
		},
		psize: {
			type: Number,
			default: 0,
		},
	},
	data () {
		return {
			isCheckAll: false,
			isIndeterminate: false,
		};
	},
	computed: {
		tableTotalLength () {
			return this.list.length;
		},
		tableSelectionLength () {
			return this.selection.length;
		},
		isCollapse () {
			return this.$store.state.commonStore.collapse;
		},

		currentPage: {
			get () {
				return this.pindex;
			},
			set (val) {
				this.$emit("update:pindex", val);
			},
		},

		pageSize: {
			get () {
				return this.psize;
			},
			set (val) {
				this.$emit("update:psize", val);
			},
		},
	},
	watch: {
		tableSelectionLength () {
			this.isCheckAll =
				this.tableTotalLength === this.tableSelectionLength &&
				this.tableSelectionLength > 0;
			this.isIndeterminate =
				this.tableSelectionLength > 0 &&
				this.tableSelectionLength < this.tableTotalLength;
		},
	},
	methods: {
		onCheckAllChange (val) {
			this.$emit("toggle");
		},
		paginationChange (e) {
			this.$emit("change");
		},
	},
};
</script>

<style lang="scss" slot-scoped>
.f-table-footer {
	position: fixed;
	bottom: 0;
	left: 160px;
	right: 0;
	background-color: #fff;
	border-bottom-left-radius: 20px;
	padding: 16px 30px 16px 60px;
	height: 60px;
	line-height: 28px;
	box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
	background-color: #fff;
	z-index: 1001;
	transition: all 0.2s;
	display: flex;
	justify-content: space-between;
	align-items: center;
	&.is-collapse {
		left: 60px;
		border-bottom-left-radius: 0px;
	}
	.checkbox {
		padding: 0 14px;
		display: inline-block;
	}
	.right {
		float: right;
	}
}
</style>
